/* Info component on the Edit Callsheet form
   telling users that the Add Cast and Add Background forms are 
   seperate from the main Callsheet form */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";

const InformationEdit2 = () => {
  return (
    <div>
        <Row className='mb-3'>
            <Col className={`px-3 py-2 ${styles.SubTitle6 }`}
             md={{span: 10, offset: 1 }}>
              <h5 className={`text-center ${styles.Red }`} >CALLSHEET ADD/EDIT INFO</h5> 
              <hr className={`mt-2 mb-0`}/> 
        <p className='pt-2'><span className={`${styles.Red}`}></span>The Callsheet Add/Edit page is divided into 2 sections.</p>
        <p className='pt-3'>SECTION 1 - THE CREW, CAST & BG/STAND-INS FORMS</p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> Click <span className={`${styles.Red}`}>Add Crew</span> to add Crew 
        from the 2nd Unit Crew Info and <span className={`${styles.Red}`}>Add Cast</span> to add Cast,
        checking their availability with the Main Unit.
        </p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> Click <span className={`${styles.Red}`}>Add BG/Stunts</span> to add Background, 
        Stand-ins, and Stunt Performers.
        </p>
        <p className='pt-4'>SECTION 2 - THE MAIN CALLSHEET FORM 
        </p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Schedule and Locations</span> are automatically
        added.
        </p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> The Hospitals Dropdown and Walkies Channels are set on the Callsheets page
        which contains their related info.
        </p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Advanced Schedule</span> Dropdown 
        to add the next Shoot Day for the Advanced Schedule.
        </p>
        <hr className={`mt-2 mb-0`}/>
        </Col>
      </Row>
    </div>
  )
}

export default InformationEdit2